import cx from "classnames";
import parse from "html-react-parser";

// Components
import Button from "../../../components/Button/ButtonContainer";

// CSS
import styles from "../conference.module.scss";

export const ConferenceSessionsSession = (props) => {
    const { session } = props;

    function renderItems() {
        return session?.items?.map((item, i) => {
            const {
                start_time,
                end_time,
                is_break,
                title,
                title_link,
                demo,
                description,
            } = item;
            return (
                <div
                    className={cx(styles.item, {
                        [styles["item--is-break"]]: is_break,
                    })}
                    key={i}
                >
                    <span className={cx(styles.times, {
                        [styles["times--hidden"]]:
                            !start_time,
                    })}
                    >
                        {start_time} - {end_time}
                    </span>

                    {title_link && (
                        <a
                          className={cx(styles.title_container, {
                              [styles["title_container--subsession"]]:
                                  !start_time,
                          })}
                          href={title_link}
                        >
                            {title && <span className={styles.title}>{parse(item.title)}</span>}
                            {demo && <span className={styles.demo}>{parse(item.demo)}</span>}
                        </a>
                    )}
                    {!title_link && (
                        <span
                          className={cx(styles.title_container, {
                              [styles["title_container--subsession"]]:
                                  !start_time,
                          })}
                        >
                            {title && <span className={styles.title}>{parse(item.title)}</span>}
                            {demo && <span className={styles.demo}>{parse(item.demo)}</span>}
                        </span>
                    )}
                    <div className={styles.description}>
                        {description && <span>{parse(item.description)}</span>}
                    </div>
                </div>
            );
        });
    }

    return (
        <div className={styles.session}>
            <div className={styles.header}>
                <div className={styles.left}>
                    {!session.title_link && <h2>{session?.title}</h2>}
                    {session.title_link && (
                        <h2>
                            <a href={session.title_link}>{session?.title}</a>
                        </h2>
                    )}
                    <span>
                        {session?.start_time} - {session?.end_time}
                    </span>
                </div>
                <div className={styles.right}>
                    {session?.calendar_link && (
                        <a
                            href={session.calendar_link}
                            rel="noreferrer"
                            target="_blank"
                        >
                            <Button
                                text="add to calendar"
                                size="thin"
                                theme="white"
                            />
                        </a>
                    )}
                </div>
            </div>
            <div className={styles.items}>
                {renderItems()}
                {session?.calendar_link && (
                    <a
                        href={session.calendar_link}
                        rel="noreferrer"
                        target="_blank"
                    >
                        <Button
                            classes={styles.button}
                            size="thin"
                            text="add to calendar"
                            theme="green"
                        />
                    </a>
                )}
            </div>
        </div>
    );
};
